// Data
import actionsServiceCaller from '../lib/app/actions-service-caller';

// Configs
import servicesConfig from '../../config/services-config';

export function standardizeGenres(genres, formName) {
    return (dispatch) => {
        const dispatchFetched = (jsonResponse) => {
            dispatch({
                formName: formName,
                type: 'STANDARDIZE_GENRE_FETCH_FULFILLED',
                response:
                    jsonResponse,
            });
        };
        const dispatchError = (error) => {
            dispatch({
                type: 'STANDARDIZE_GENRES_REJECTED',
                error,
            });
        };
        const actionParams = {
            servicesConfig: servicesConfig.standardizedGenres,
            dispatchFetched,
            dispatchError,
        };

        return Promise.resolve(actionsServiceCaller(actionParams, {genres: genres}));
    };
}

export default standardizeGenres;